import { createElement, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import Authorize from 'pages/Authorize';
import { AuthorizeProvider } from 'pages/Authorize/AuthorizeProvider';
import RedirectBase from 'pages/RedirectBase';
import { customOauthCallbackRoutes } from './pages/Authorize/OAuth/custom-oauth-callback-routes';
import { AnalyticsEventName, track } from 'utils/analytics';
import { useInitializeStagedConfig } from './pages/Authorize/useStagedConfig';
import { CompleteSession } from './pages/CompleteSession';

function App() {
  useEffect(() => {
    track(AnalyticsEventName.LaunchedFinchConnect);
  }, []);

  useInitializeStagedConfig();

  return (
    <AuthorizeProvider>
      <Switch>
        <Route
          path="/authorize"
          render={(props) => <Authorize location={props.location} />}
        />
        {customOauthCallbackRoutes.map((route) => (
          <Route
            path={route.path}
            key={route.path}
            render={() => createElement(route.component)}
          />
        ))}
        <Route path="/complete-session" render={() => <CompleteSession />} />
        <Route path="*" render={() => <RedirectBase />} />
      </Switch>
    </AuthorizeProvider>
  );
}

export default App;
